import React, { useState } from 'react';
import { BankDetailsScreen, BankDetails } from './screens/BankDetailsScreen';
interface BankAccountJourneyProps {
  onComplete: () => void;
  onExit: () => void;
}
export function BankAccountJourney({
  onComplete,
  onExit
}: BankAccountJourneyProps) {
  const [bankDetails, setBankDetails] = useState<BankDetails | null>(null);
  const handleNext = (details: BankDetails) => {
    setBankDetails(details);
    onComplete();
  };
  return <div className="h-full w-full max-w-4xl mx-auto p-6" data-id="element-2">
      <BankDetailsScreen initialDetails={bankDetails || undefined} onBack={onExit} onNext={handleNext} data-id="element-3" />
    </div>;
}